module.exports = __webpack_public_path__ + "static/media/icon_instrument_bass_guitar.72a82c1c.svg";